import { ButtonHTMLAttributes, FC, ReactNode } from 'react';

export type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Required: an icon-only control has no other accessible name. */
  label: string;
  variant?: 'ghost' | 'danger';
  size?: 'sm' | 'md';
  children: ReactNode;
};

const IconButton: FC<IconButtonProps> = ({ label, variant = 'ghost', size = 'md', className, children, ...rest }) => (
  <button
    type="button"
    {...rest}
    aria-label={label}
    title={rest.title ?? label}
    className={[
      'ui-icon-button',
      variant === 'danger' ? 'ui-icon-button--danger' : undefined,
      size === 'sm' ? 'ui-icon-button--sm' : undefined,
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {children}
  </button>
);

export default IconButton;
